export async function loadMarkdown(file) {
  const response = await fetch(`help/${file}`);
  if (!response.ok) {
    document.getElementById('help-content').textContent = `Failed to load help: ${response.status}`;
    return;
  }
  let markdown = await response.text();

  markdown = markdown.replace(/!\[([^\]]*)\]\(([^/)][^)]*)\)/g, '![$1](help/$2)');
  
  document.getElementById('help-content').innerHTML = marked.parse(markdown);
  
  document.querySelectorAll('#help-content a[href$=".md"]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      loadMarkdown(link.getAttribute('href'));
    });
  });
}

export function showHelp() {
  document.getElementById('map-player').style.display = 'none';
  document.getElementById('help-viewer').style.display = 'block';
  loadMarkdown('help.md');
}

export function hideHelp() {
  document.getElementById('help-viewer').style.display = 'none';
  document.getElementById('map-player').style.display = 'block';
}
